import {Component, Input} from '@angular/core';
import {AppLinkBuilder} from '../../../utils';
import {IoniconsFilled, IoniconsOutline} from '@pt/pt-models';
import {
  ApplicationAdministrator
} from 'it/primatoo/openapi/api/org/schemas/application/getapplicationfordetailsresponse/_getapplicationfordetailsresponse/ApplicationAdministrator';

@Component({
  selector: 'pt-details-layout',
  templateUrl: './details-layout.component.html',
  styleUrls: ['./details-layout.component.scss']
})
export class DetailsLayoutComponent {
  @Input() title!: string;
  @Input() noDataMessage!: string;
  @Input() showNoData = false;

  @Input() showWarning = false;
  @Input() warningMessage?: string;

  @Input() showInfo = false;
  @Input() infoMessage?: string;
  @Input() margin?: string;

  IconUser = IoniconsFilled.user;
  IconWarning = IoniconsOutline.warning;
  IconInfo = IoniconsOutline.infoCircle;

  openAdministrator(admin: ApplicationAdministrator) {
    window.open(AppLinkBuilder.linkOfEntity('userResources', admin.id), '_blank');
  }
}
